import React from 'react';
import { useState, useEffect } from 'react' 
import { Link } from 'react-router-dom';
import { db } from '../../../../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot } from 'firebase/firestore';

const Flutter = () => {  
    return (
        <>
            {/* <div className="page-hd clearfix">
                <div className="left-float" style={{marginTop: "0px", marginRight: "20px"}}>
                    <img src="/images/skin1/react-logo.png" /> 
                </div>
                <div className="left-float" style={{marginTop: "10px"}}>
                    <p><strong>Experience: 4 Years</strong></p>
                    <p><strong></strong></p>
                </div>
            </div> */}
            <h1>Flutter <h3>- 1 Year</h3></h1> 
             <ul>
                <li>- Created a mobile based Flutter project for an Oracle based Order Search system.</li>
                
            </ul>
        </>
    )
}
export default Flutter;